var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('a-input',{ref:"input",staticClass:"xt-myself-input",attrs:{"size":"large","placeholder":"请输入您的昵称","max-length":25},model:{value:(_vm.inputValue),callback:function ($$v) {_vm.inputValue=$$v},expression:"inputValue"}})
}
var staticRenderFns = []

export { render, staticRenderFns }